import { createAction, props } from '@ngrx/store';
import { IUser } from '../model/user.model';
import { IUserLogin } from '../model/user-login.model';
import { IUserRegister } from '../model/user-register.model';
import { IWaitingList } from '../model/waitingList.model';

export const login = createAction('[User] Login', props<{ user: IUserLogin }>());
export const loginWithSso = createAction('[User] Login With SSO', props<{ token: string }>());

export const loginSuccess = createAction('[User] Login Success', props<{ user: IUser }>());
export const loginFailure = createAction('[User] Login Failure', props<{ error: string }>());
export const logout = createAction('[User] Logout');
export const logoutSuccess = createAction('[User] Logout Success');
export const logoutTimeout = createAction('[User] Logout Timeout');
export const logoutTimeoutSuccess = createAction('[User] Logout Timeout Success');

export const retryLogin = createAction('[User] Retry Login');
export const retryLoginFailure = createAction('[User] Retry Login Failure', props<{ error: string }>());

export const setUser = createAction('[User] Set User', props<{ user: IUser }>());
export const userRegister = createAction('[User] User Register', props<{ user: IUserRegister }>());
export const userRegisterSuccess = createAction('[User] User Register Success');

export const updatePicture = createAction('[User] Update Picture', (imageData: string | File) => ({ imageData }));
export const updatePictureSuccess = createAction('[User] Update Picture Success', (imageUrl: string) => ({ imageUrl }));
export const updatePictureFailure = createAction('[User] Update Picture Failure', (error: string) => ({ error }));

export const updateGeneralData = createAction('[User] Update General Data', (name: string, email: string, login: string) => ({ name, email, login }));
export const updateGeneralDataSuccess = createAction('[User] Update General Data Success', (name: string, email: string, login: string) => ({ name, email, login }));
export const updateGeneralDataFailure = createAction('[User] Update General Data Failure', (error: string) => ({ error }));

export const updateGeneralSettings = createAction('[User] Update General Settings',
            (timeout: number, publicProfile: boolean, nostrPK: string) => ({ timeout, publicProfile, nostrPK }));
export const updateGeneralSettingsSuccess = createAction('[User] Update General Settings Success',
            (timeout: number, publicProfile: boolean, nostrPK: string) => ({ timeout, publicProfile, nostrPK }));
export const updateGeneralSettingsFailure = createAction('[User] Update General Settings Failure', (error: string) => ({ error }));

export const waitingListRegister = createAction('[User] Waiting List Register', props<{ user: IWaitingList }>());
export const waitingListRegisterSuccess = createAction('[User] Waiting List Register Success');

export const userActions = {
    login,
    loginSuccess,
    loginFailure,
    loginWithSso,

    logout,
    logoutSuccess,
    logoutTimeout,
    logoutTimeoutSuccess,

    retryLogin,
    retryLoginFailure,

    setUser,
    userRegister,
    userRegisterSuccess,

    updatePicture,
    updatePictureSuccess,
    updatePictureFailure,

    updateGeneralData,
    updateGeneralDataSuccess,
    updateGeneralDataFailure,

    updateGeneralSettings,
    updateGeneralSettingsSuccess,
    updateGeneralSettingsFailure,

    waitingListRegister,
    waitingListRegisterSuccess
}

